import React 			from 'react';
import ReactDOM 		from 'react-dom';
import BLComponent 		from '../core/_BLComponent.jsx';

import SellerStoreLockup		from '../common/_SellerStoreLockup.jsx';
import SellerBox 				from './_SellerBox.jsx';
import {CustomAlert, ClickShowTooltip}	from '../common/_Utilities.jsx';
import WantedButton 			from '../common/_WantedButton.jsx';
import ControlledNumberInput 	from '../common/_ControlledNumberInput.jsx';
import ModalFrame				from '../common/_ModalFrame.jsx';
import LazyLoad					from '../common/_LazyLoad.jsx';
import AddToCartModal			from '../modals/_AddToCartModal.jsx';
import FloatingImage			from '../common/_FloatingImage';

export default class StoreListingsPage extends BLComponent
{
	constructor(props) 
	{
		super(props);

		this.itemData		= blapp.models.get( "itemInfo" );
		this.cartData		= blapp.models.get( "cartInfo" );
		this.mapCart		= {};
		this.idItem			= blapp.util.getUrlVar( "idItem" );
		this.idColor 		= blapp.util.getUrlVar( "idColor" ) || -1;

		if ( this.cartData != null )
			_.forEach( this.cartData, ( cart ) => { this.mapCart[ cart.idStore ] = cart; } );

		let	qty		= parseInt( blapp.util.getUrlVar( "qty" ) );
		let	cond	= blapp.util.getUrlVar( "cond" );
		let	type	= blapp.util.getUrlVar( "type" );

		this.state = 	{
							dummy:			0
						,	view: 			type
						,	sortOrder: 		"item_price"
						,	stores: 		[]
						,	selectedQty:	isNaN( qty ) ? 1 : qty
						,	selectedCond:	cond
						,	status:			0		// 0: Loading, 1: Found, 2: To LEGO Shop (deprecated), 3: No IC, 4: No Available, -1: Error 
						,	chosenStore:	0
						,	isWanted:		false
						,	hasMore:		false
						,	sellerNotesModal: false
						,	sellerTermsModal: false
						,	loadingMore: 	true
						,	showAddToCart:	false
						,	selectedTermsDate: 0
						,	selectedShipTermsDate: 0
						,	termsView: 1
						};

		this.nPageSize	= 50;

		this.bindStateWithQS( "view", "type", true );
		this.bindStateWithQS( "selectedQty", "qty", true );
		this.bindStateWithQS( "selectedCond", "cond", true );
	}

	componentDidMount() 
	{
		this.fetchInvResult();
		if ( blapp.session.isLoggedIn() ) 
		{
			this.fetchWantedInfo();
			this.updateMyWantedQty();
		}
	}

	render() 
	{
		let chosenInvData	= this.chosenInvData;
		let maxBuyableQty	= this.resultData ? this.resultData.nTotalQtyMatching : null;
		let invStatus		= 0;
		let	cond_string		= "";
		let	dCnt			= this.resultData ? this.resultData.nDomesticStoreCnt : 0;
		let	iCnt			= this.resultData ? this.resultData.nIntlStoreCnt : 0;

		if ( this.state.status == 1 )
		{
			if ( this.resultData == null )
				invStatus	= -1;
			else if ( this.chosenInvData != null )
				invStatus	= 1;
			else if ( this.resultData.nTotalQtyAvailable > 0 )
				invStatus	= 3;
			else if ( this.resultData.nTotalQtyAvailable == 0 )
				invStatus	= 4;
			else
				invStatus	= -1;
		}
		else if ( this.state.status == -1 )
		{
			invStatus	= -1;
		}

		switch ( this.state.selectedCond )
		{
		case "NS":	cond_string	= $T("NEW_SEALED");	break;
		case "NC":	cond_string	= $T("NEW_COMPLETE");	break;
		case "UC":	cond_string	= $T("USED_COMPLETE");	break;
		case "N":	cond_string	= $T("NEW");			break;
		case "U":	cond_string	= $T("USED");			break;
		}

		let		condItems	= [];
		const wantedQty = this.state.wantedQty;

		if ( this.itemData.dmBasic.typeItem == "S" )
		{
			condItems	=	[
								<option key="NS" value="NS">{$T("NEW_SEALED")}</option>
							,	<option key="NC" value="NC">{$T("NEW_COMPLETE")}</option>
							,	<option key="UC" value="UC">{$T("USED_COMPLETE")}</option>			
							];
		}
		else
		{
			condItems	=	[
								<option key="N" value="N">{$T("NEW")}</option>
							,	<option key="U" value="U">{$T("USED")}</option>			
							];
		}

		return (
			<div className="main main--white">
				{this.renderSellerNotesModal()}
				{this.renderSellerTermsModal()}
				<div className="main__content main__content--tight-mob">
					<header className="store-listings__head">
						<a className="l-block store-listings__head-back" href="#" onClick={(e)=>{e.preventDefault(); e.stopPropagation(); window.history.back(); }}><i className="fas fa-long-arrow-left l-margin-right--sm"/>{$T("BACK_TO_ITEM_DETAILS")}</a>
						<h1 className="pdp__header-title">{$T("ALL_LISTINGS")} for {this.itemData.dmBasic.strItemName}</h1>
						<p className="l-hide--desktop l-margin-top l-nowrap">{this.state.selectedQty}x {cond_string} (<button className="btn btn--link" onClick={() => this.setState({showUserSelection: !this.state.showUserSelection})}>{this.state.showUserSelection ? 'close' : 'change'}</button>)</p>
						
						{this.state.showUserSelection &&
							<section className="store-listings__user-selector">
								<div className="pdp__user-selection-item">
									<strong>{$T("QUANTITY")}</strong>
									<ControlledNumberInput value={this.state.selectedQty} onChangeFunc={(value) => this.setState({selectedQty: isNaN(value) || value < 1 ? 1 : value})}/>
									{wantedQty ? <small className="l-block text--note">{$T("WANTED_QTY")} {wantedQty}</small> : null}
								</div>
								<div className="pdp__user-selection-item">
									<strong>{$T("CONDITION")}<i className="fas fa-info-circle l-margin-left--sm js-bottom-right-tooltip" data-tooltip={$T("ONLY_COMPLETE_SETS")} data-tooltip-width={126} onClick={(e) => ClickShowTooltip(e)}/></strong>
									<select className="select l-full-width" value={this.state.selectedCond} onChange={(e)=>this.setState({selectedCond: e.target.value})}>
									{condItems}
									</select>
								</div>
							</section>
						}
					</header>
					<div className="mdc-layout-grid l-pad-null store-listings__grid">
						<div className="mdc-layout-grid__inner">

							<div className="store-listings__main mdc-layout-grid__cell mdc-layout-grid__cell--span-8-desktop mdc-layout-grid__cell--span-8-desktop-l mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
								<div className="store-listings__filters">
									<ul className="store-listings__view-selector view-selector view-selector--bordered">
										<li className={"view-selector__item" + (this.state.view == 'D' ? " view-selector__item--active" : "")} onClick={dCnt >= 0 ? () => this.setState({view: 'D'}) : null}>
											<span className="view-selector__item-content">{$T("DOMESTIC")} { dCnt > 0 ? `(${dCnt})` : '' }</span>
										</li>
										<li className={"view-selector__item" + (this.state.view == 'I' ? " view-selector__item--active" : "")} onClick={iCnt >= 0 ? () => this.setState({view: 'I'}) : null}>
											<span className="view-selector__item-content">{$T("INTERNATIONAL")} { iCnt > 0 ? `(${iCnt})` : '' }</span>
										</li>
									</ul>
									<div className="store-listings__sort">
										<label htmlFor="sort-by">{$T("SORT_BY")}</label>
										<select className="select select--tight l-margin-left--sm" onChange={(e) => this.setState({sortOrder: e.target.value})}>
											<option value={"item_price"}>{$T("SORT_ITEM_PRICE")}</option>
											<option value={"qty"}>{$T("SORT_QUANTITY")}</option>
											<option value={"fdb_pos"}>{$T("SORT_POS_FEEDBACK")}</option>
											<option value={"fdb_neg"}>{$T("SORT_NEG_FEEDBACK")}</option>
										</select>
									</div>
								</div>
								{this.renderListings()}
							</div>

							<div className="pdp-grid__sidebar store-listings__sidebar mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-4-desktop-l mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
								<SellerBox 
									typeItem={this.itemData.dmBasic.typeItem}
									selectedQty={parseInt( this.state.selectedQty )}
									selectedCond={this.state.selectedCond}
									status={invStatus}
									chosenInvData={chosenInvData ? chosenInvData : null}
									maxBuyableQty={maxBuyableQty}
									wantedQty={wantedQty}
									classes={'store-listings__seller-box'}
									func={
										{
											triggerZoomModal: (images) => {}
										,	updateQty: (value) => this.setState({selectedQty: isNaN(value) || value < 1 ? 1 : value})
										,	updateCond: (value) => this.setState({selectedCond: value})
										,	doAddToCart: () => this.doAddToCart()
										,	doEasyBuy: () => this.doEasyBuy()
										,	toggleSellerNotesModal: () => this.setState({sellerNotesModal: !this.state.sellerNotesModal})
										,	toggleSellerTermsModal: () => this.setState({sellerTermsModal: !this.state.sellerTermsModal})
										}
									}
								/>
								<div className="l-margin-y--xl l-hide--small">
									<WantedButton classes="l-full-width" data={{item: this.itemData.dmBasic, qty: this.state.selectedQty, color: this.state.selectedColor}} isWanted={this.state.isWanted} addToWantedList={()=>this.doAddToWanted()}/>
								</div>
							</div>
						</div>
					</div>
				</div>
				{this.state.showAddToCart ? <AddToCartModal moreProducts={this.storeSuggestItems} storeName={this.chosenInvData.dmStore.strStoreName} storeId={this.chosenInvData.dmStore.idStore} product={{}} func={{toggleModal: () => this.setState({showAddToCart: false})}}/> : null}
			</div>
		);
	}

	renderSellerNotesModal() 
	{
		if ( !this.state.sellerNotesModal || this.resultData == null )
			return;

		const findIdx		= _.findIndex( this.resultData.arrAltStores, ( st ) => ( st.dmStore.idStore == this.state.chosenStore ) );
		const data 			= this.resultData.arrAltStores[ Math.max( findIdx, 0 ) ];

		if ( data == null )
			return;

		const	store		= data.dmStore;
		const	st			= blapp.country.getStateLegacy( store.idState );
		const	country		= blapp.country.get( store.codeCountry );
		const	location 	= country ? ( ( ( st && !_.isEmpty( st.strStateName ) ) ? st.strStateName + ", " : "" ) + country.strCountryName ) : "";

		let	invs 				= [];
		let inv 				= '';
		let sellerNote 			= '';
		let sellerImage 		= '';
		let sellerNoteExtended 	= '';

		_.forEach(data.mapInvs, (inv) => invs.push(inv));

		invs.sort((l, r) => r.nBuyQty - l.nBuyQty);

		inv							= invs[0];
		sellerNote 					= inv.dmInv.strDesc;
		sellerImage 				= blapp.url2.getInvImgUrl(inv.dmInv);
		sellerNoteExtended			= inv.strExtendedDesc;

		return (
			<ModalFrame classes="modal--large" title={this.itemData.dmBasic.strItemName} closeFunc={() => this.setState({sellerNotesModal: false})}>
				<section className="l-margin-bottom--xl">
					<SellerStoreLockup classes="store-detail-lockup--large" details={{storeName: data.dmStore.strStoreName, flag: data.dmStore.codeCountry, feedbackScore: data.dmStore.nFeedbackScore, favorite: data.isFavorite }}/>
					<div className="pdp__seller-notes-header-info">
						<div>{location}</div>
						<div>Lot ID: {inv.dmInv.idInv}, Item no: {this.itemData.dmBasic.strItemNoFull}</div>
					</div>
				</section>
				<section>
					{sellerImage &&
						<figure className="l-margin-bottom--xl">
							<FloatingImage><img src={sellerImage}/></FloatingImage>
						</figure>
					}
					<h3 className="text--small-title text--bold l-margin-bottom">Note from seller</h3>
					{sellerNote && <pre className="text--pre-line" dangerouslySetInnerHTML={{__html: sellerNote}}/>}
					{sellerNoteExtended && <pre className="l-margin-top--xl text--pre-line" dangerouslySetInnerHTML={{__html: sellerNoteExtended}}/>}
				</section>
			</ModalFrame>
		);
	}


	renderSellerTermsModal() {
		if ( !this.state.sellerTermsModal || this.resultData == null )
			return;

		const findIdx		= _.findIndex( this.resultData.arrAltStores, ( st ) => ( st.dmStore.idStore == this.state.chosenStore ) );
		const data 			= this.resultData.arrAltStores[ Math.max( findIdx, 0 ) ];

		if ( data == null )
			return;

		const store 		= data.dmStore;
		const	st				= blapp.country.getStateLegacy( store.idState );
		const	country		= blapp.country.get( store.codeCountry );
		const	location 	= country ? ( ( ( st && !_.isEmpty( st.strStateName ) ) ? st.strStateName + ", " : "" ) + country.strCountryName ) : "";

		const terms			= data.storeTerms ? data.storeTerms.storeTerms : null;
		const termsChange	= data.storeTerms && data.storeTerms.storeTermsChange.length > 0 ? data.storeTerms.storeTermsChange : null
		const termsContent	= termsChange ? termsChange[parseInt(this.state.selectedTermsDate)].content : terms;

		const shipTerms			= data.storeTerms ? data.storeTerms.shippingTerms : null;
		const shipTermsChange	= data.storeTerms && data.storeTerms.shippingTermsChange.length > 0 ? data.storeTerms.shippingTermsChange : null
		const shipTermsContent	= shipTermsChange ? shipTermsChange[parseInt(this.state.selectedShipTermsDate)].content : shipTerms;
		
		if(this.state.sellerTermsModal && terms) {
			return (
				<ModalFrame classes="modal--large terms-modal" title={$T("STORE_TERMS")} closeFunc={() => this.setState({sellerTermsModal: false})}>
					<header className="terms-modal__header">
						<div className="terms-modal__store-details">
							<SellerStoreLockup classes="store-detail-lockup--large" details={{storeName: data.dmStore.strStoreName, flag: data.dmStore.codeCountry, feedbackScore: data.dmStore.nFeedbackScore }}/>
							<p className="text--note l-margin-top--sm">{location}</p>
						</div>
					</header>
					<ul className="view-selector l-border--bottom l-margin-bottom">
						<li className={"view-selector__item" + (this.state.termsView == 1 ? ' view-selector__item--active' : '')} onClick={() => this.setState({termsView: 1})}>
							<button className="btn btn--blank view-selector__item-content">Terms and policies</button>
						</li>
						<li className={"view-selector__item" + (this.state.termsView == 2 ? ' view-selector__item--active' : '')} onClick={() => this.setState({termsView: 2})}>
							<button className="btn btn--blank view-selector__item-content">Shipping <span className="l-hide--small">information</span><span className="l-hide--desktop">info</span></button>
						</li>
					</ul>
					{this.state.termsView == 1 ?
						<article>
							{termsChange && termsChange.length > 0 ?
								<label className="terms-modal__date">
									<span className="text--no-wrap">Last updated:</span>
									<select className="select l-margin-left--sm l-full-width" onChange={(e) => this.setState({selectedTermsDate: e.target.value})}>{termsChange.map((updates, key) => <option value={key}>{blapp.format.formatDateTime(updates.date)}</option>)}</select>
								</label>
							:
								null
							}
							<div dangerouslySetInnerHTML={{__html: termsContent}}/>
						</article>
					:
						<article>
							{shipTermsChange && shipTermsChange.length > 0 ?
								<label className="terms-modal__date">
									<span className="text--no-wrap">Last updated:</span>
									<select className="select l-margin-left--sm l-full-width" onChange={(e) => this.setState({selectedShipTermsDate: e.target.value})}>{shipTermsChange.map((updates, key) => <option value={key}>{blapp.format.formatDateTime(updates.date)}</option>)}</select>
								</label>
							:
								null
							}
							<div dangerouslySetInnerHTML={{__html: shipTermsContent}}/>
						</article>
					}
				</ModalFrame>
			);
		}
	}

	renderListings() 
	{
		let		listings	= [];

		if ( this.state.status == 0 )
		{
			listings.push( <div key="loading" className="l-pad--xxl text--center">{$T("LOADING")}</div> );
		}
		else if ( this.state.status == -1 )
		{
			listings.push( <div key="error" className="l-pad--xxl text--center">{$T("ERROR")}</div> );			
		}
		else if ( this.resultData && this.resultData.arrAltStores )
		{
			listings	= this.resultData.arrAltStores.map( ( s ) => this.renderListingItem( s ) );
		}


		return (
			<div className="store-listings__table flex-table">
				<div className="store-listings__table-head flex-table__header l-pad-x">
					<div className="flex-table__cell flex-table__cell--40 store-listings__table-cell">
						{$T("STORE")}
					</div>
					<div className="flex-table__cell flex-table__cell--30 store-listings__table-cell">
						{$T("FEEDBACK")}
					</div>
					<div className="flex-table__cell flex-table__cell--10 store-listings__table-cell store-listings__table-cell--qty">
						{$T("QTY")}
					</div>
					<div className="flex-table__cell flex-table__cell--20 flex-table__cell--align-right store-listings__table-cell">
						{$T("ITEM_PRICE")}
					</div>
				</div>
				<div>
					{listings}
				</div>
				{this.state.hasMore && <LazyLoad disable={this.state.loadingMore == true} callbackFunc={() => this.loadMore()}/>}
			</div>
		);
	}

	renderListingItem( s ) 
	{
		let	nBuyQty		= 0;
		let	cartLotQty	= 0;
		let	couponCnt	= s.nCouponCnt;
		let	isChosen	= ( s.dmStore.idStore == this.state.chosenStore );

		if ( s.mapInvs )
			_.forEach( s.mapInvs, ( inv ) => { nBuyQty += inv.nBuyQty } );
		else
			nBuyQty	= s.nMatchingInvQty;

		if ( this.mapCart[ s.dmStore.idStore ] )
		{
			cartLotQty	= this.mapCart[ s.dmStore.idStore ].nLotCntTotal;
		}

		//let	unitPrice			= s.mTotalItemNetPriceInDisplayCurrency / nBuyQty;
		//let	unitPriceInStore	= s.mTotalItemNetPriceInStoreCurrency / nBuyQty;
		let c					= blapp.country.get( s.dmStore.codeCountry );
		const	st				= blapp.country.getStateLegacy( s.dmStore.idState );
		const	location 		= c ? ( ( ( st && !_.isEmpty( st.strStateName ) ) ? st.strStateName + ", " : "" ) + c.strCountryName ) : ""

		return (
			<div className={"store-listings__table-row flex-table__row l-pad" + ( isChosen ? " flex-table__row--active" : "" )} key={s.dmStore.idStore} onClick={(e)=>this.selectStore(s)}>
				<div className="store-listings__table-cell store-listings__table-cell--store flex-table__cell flex-table__cell--40">
					<div>
						<SellerStoreLockup details={{storeName: s.dmStore.strStoreName, flag: s.dmStore.codeCountry, feedbackScore: s.dmStore.nFeedbackScore, favorite: s.isFavorite}}/>
						<p className="text--note l-margin-top--xs">{location}</p>
					</div>
				</div>
				<div className="store-listings__table-cell store-listings__table-cell--feedback flex-table__cell flex-table__cell--30">
					<span className="l-margin-right--sm store-listings__table-feedback-item"><i className={(isChosen ? "fas" : "fad") + " fa-comment-plus fa-fw text-color--primaryGreen l-margin-right--sm"}/>{s.dmStore.nPosFdbCnt}</span>
					<span className="l-margin-left--sm store-listings__table-feedback-item"><i className={(isChosen ? "fas" : "fad") + " fa-comment-minus fa-fw text-color--primaryRed l-margin-right--sm"}/>{s.dmStore.nNegFdbCnt}</span>
				</div>
				<div className="store-listings__table-cell store-listings__table-cell--qty flex-table__cell flex-table__cell--10">
					<span className="l-hide--tablet l-margin-right--xs">{$T("QTY")}:</span> {s.nMatchingInvQty}
				</div>
				<div className="store-listings__table-cell store-listings__table-cell--price flex-table__cell flex-table__cell--20 flex-table__cell--align-right">
					<div>
						<strong>{couponCnt > 0 && <i className="far fa-tag fa-flip-horizontal l-margin-right js-bottom-center-tooltip" data-tooltip={$T("N_COUPONS_AVAILABLE",[couponCnt])} data-tooltip-width={126} onClick={(e) => ClickShowTooltip(e)}/>}
						{blapp.format.formatMoney(s.mTotalItemNetPriceInDisplayCurrency,blapp.session.idCurrencyDetected)}</strong>
						{
							( blapp.session.idCurrencyDetected != s.dmStore.idStoreCurrency ) || couponCnt > 0 ?
							<div>
								{( blapp.session.idCurrencyDetected != s.dmStore.idStoreCurrency ) ? <div>{blapp.format.formatMoney(s.mTotalItemNetPriceInStoreCurrency,s.dmStore.idStoreCurrency)}</div> : null}
							</div>
							: 
							null
						}
						{s.dmStore.mMinBuy != 0 && <small className="l-block">Min. buy: {blapp.format.formatMoney(s.dmStore.mMinBuy, s.dmStore.idStoreCurrency)}</small>}
					</div>
				</div>
				<div className="store-listings__table-cell store-listings__table-cell--extra">
					{
						this.state.view == 'I' || cartLotQty > 0 ?
						<div className="l-margin-right">
							{this.state.view == 'I' ? <div>{c.strCountryName}</div> : null}
							{cartLotQty > 0 ? <div>{$T("N_LOTS_IN_CARTS",[cartLotQty])}</div> : null}
						</div>
						: 
						null
					}
					
				</div>
			</div>
		);
	}

	componentDidUpdate( prevProps, prevState, snapshot ) 
	{ 
		super.componentDidUpdate( prevProps, prevState, snapshot ); 

		if ( (prevState.selectedQty != this.state.selectedQty && !isNaN(this.state.selectedQty))
			|| prevState.selectedCond != this.state.selectedCond
			|| prevState.view != this.state.view 
			|| prevState.sortOrder != this.state.sortOrder )
		{
			this.setState( { status: 0 } );
			this.fetchInvResult();
			this.updateMyWantedQty();
		}

		/*
		if ( prevState.chosenStore != this.state.chosenStore )
		{
			this.fetchStoreResult();
		}
		*/
	}

	updateMyWantedQty()
	{
		const	itemBasic	= this.itemData.dmBasic;
		const	idColor		= this.idColor;
		const	isNew		= this.state.selectedCond == "UC" || this.state.selectedCond == "U" ? false : true;

		blapp.models.fetch(
			"_my_wanted_cnt"
		,	{
				controller:	"wanted.BLCWanted"
			,	method:		"getMyWantedCnt"
			,	params:		[ itemBasic.idItem, idColor, null, isNew ]
			,	refresh:	true
			}
		).then( 
			( data ) => 
			{
				this.setState( { wantedQty: data } );
			}
		).catch(
			( err ) =>
			{
				console.log(err);
			}
		);
	}

	fetchWantedInfo()
	{
		const	itemBasic	= this.itemData.dmBasic;
		const	idColor		= this.idColor;

		blapp.personalized.fetchWantedPrefData( 
			itemBasic.idItem
		,	idColor
		,	( data ) =>
			{
				if ( data && data.dataWantedPref )
				{
					this.setState( { isWanted: data.dataWantedPref.bIsWanted } );
				}
			}
		);			
	}


	fetchInvResult( newPageIdx )
	{
		const	isNew		= this.state.selectedCond == "UC" || this.state.selectedCond == "U" ? false : true;
		const	isSealed	= this.state.selectedCond == "NC" || this.state.selectedCond == "UC" ? false : true;
		const	resultType	= this.state.view == 'D' ? "DOMESTIC" : "INTL_ALL";

		this.setState({loadingMore: true});

		if ( newPageIdx == null )
		{
			this.resultData	= null;
			this.setState( { status: 0 } );
		}

		blapp.models.fetch(
			"_inv_result"
		,	{
				controller:	"finder.BLCInvFinder"
			,	method:		"findSingleItemResult"
			,	params:		[ this.idItem, this.idColor, isNew ? 'N' : 'U', isSealed ? 'S' : 'C', this.state.selectedQty, 0, resultType, this.state.sortOrder, newPageIdx ? newPageIdx : 1, this.nPageSize ]
			,	refresh:	true
			}
		).then( 
			( data ) => 
			{
				if ( data.codeNew != ( this.state.selectedCond == "UC" || this.state.selectedCond == "U" ? 'U' : 'N' ) )
					return;
				if ( data.codeComplete == 'X' && this.state.selectedCond.length != 1 )
					return
				if ( data.codeComplete == 'S' && this.state.selectedCond != "NS" )
					return;
				if ( data.codeComplete == 'C' && this.state.selectedCond != "NC" && this.state.selectedCond != "UC" )
					return;
				if ( data.typeResult == "DOMESTIC" && this.state.view != 'D' )
					return;
				if ( data.typeResult == "INTL_ALL" && this.state.view != 'I' )
					return;


				let	prevArrStore	= this.resultData ? this.resultData.arrAltStores : null;
				this.resultData		= data;

				let chosenStoreData = null;

				if ( data.arrAltStores && data.arrAltStores.length > 0 )
				{
					if ( !_.isEmpty( prevArrStore ) && prevArrStore.length == ( data.nAltStoreCurPage - 1 ) * data.nAltStorePageSize )
						data.arrAltStores	= _.concat( prevArrStore, data.arrAltStores );

					let	findIdx	= _.findIndex( data.arrAltStores, ( st ) => ( st.dmStore.idStore == this.state.chosenStore ) );

					chosenStoreData	= data.arrAltStores[ Math.max( findIdx, 0 ) ];
				}

				this.chosenInvData	= chosenStoreData;
				
				this.setState( 
					{ 
						status: 		1
					,	chosenStore: 	( chosenStoreData ? chosenStoreData.dmStore.idStore : 0 )
					, hasMore:		data.nTotalAltStores > data.arrAltStores.length ? true : false
					,	loadingMore: false
					} 
				);
			}
		).catch(
			( err ) =>
			{
				this.setState( { status: -1 } );
			}
		);		
	}

	fetchStoreResult()
	{
		const	isNew		= this.state.selectedCond == "UC" || this.state.selectedCond == "U" ? false : true;
		const	isSealed	= this.state.selectedCond == "NC" || this.state.selectedCond == "UC" ? false : true;

		blapp.models.fetch(
			"_store_result"
		,	{
				controller:	"finder.BLCInvFinder"
			,	method:		"getSingleItemStoreResult"
			,	params:		[ this.idItem, this.idColor, isNew, isSealed, this.state.selectedQty, this.state.chosenStore ]
			,	refresh:	true
			}
		).then( 
			( data ) => 
			{
				if ( data.codeNew != ( this.state.selectedCond == "UC" || this.state.selectedCond == "U" ? 'U' : 'N' ) )
					return;
				if ( data.codeComplete == 'X' && this.state.selectedCond.length != 1 )
					return
				if ( data.codeComplete == 'S' && this.state.selectedCond != "NS" )
					return;
				if ( data.codeComplete == 'C' && this.state.selectedCond != "NC" && this.state.selectedCond != "UC" )
					return;
				if ( data.srRecommended.dmStore.idStore != this.state.chosenStore )
					return;

				this.chosenInvData	= data.srRecommended;

				this.setState( { dummy: this.state.dummy + 1 } );
			}
		).catch(
			( err ) =>
			{
				this.chosenInvData	= null;
				this.setState( { dummy: this.state.dummy + 1 } );
			}
		);				
	}

	loadMore()
	{
		if(this.resultData) {
			this.fetchInvResult( this.resultData.nAltStoreCurPage + 1 );
		}
	}

	selectStore( store )
	{
		if ( store && store.dmStore.idStore != this.state.chosenStore )
		{
			this.chosenInvData	= store;
			this.setState( { chosenStore: store.dmStore.idStore } );
		}
	}

	refreshCart()
	{
		blapp.models.fetch(
			"cartInfo"
		,	{
				controller:	"cart.BLCCart"
			,	method:		"getMyStoreCartBasicList"
			,	params:		[]
			,	refresh:	true
			}
		).then( 
			( data ) =>
			{
				this.cartData	= data;
				this.mapCart	= {};
				if ( this.cartData != null )
					_.forEach( this.cartData, ( cart ) => { this.mapCart[ cart.idStore ] = cart; } );
				this.setState( { dummy: this.state.dummy + 1 } );
			}
		);
	}

	triggerAlert(message) 
	{
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i><p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent);
	}

	doAddToWanted()
	{
		const	itemBasic	= this.itemData.dmBasic;
		let		itemImg		= itemBasic.imgDefault;

		if ( itemBasic.typeItem == "P" && this.itemData.mapColorImgs && this.itemData.mapColorImgs[ this.idColor ] )
		{
			itemImg	= this.itemData.mapColorImgs[ this.idColor ];
		}
		
		blapp.wanted.showAddWantedListModal( 
			{ dmItem: itemBasic, dmImg: itemImg, idColor: this.idColor, nWantedQty: this.state.selectedQty, selectedCond: blapp.wanted.getWantedCond(this.state.selectedCond) }
		,	() => { this.fetchWantedInfo(); ; this.updateMyWantedQty(); }
		,	{
				location:		blapp.srcmap.LOCATION.CATALOG_ITEM_DETAIL_XP
			,	typeSrcFrom:	blapp.srcmap.SRCTYPE.CATALOG_ITEM
			,	idSrcFrom:		itemBasic.idItem
			}
		);		
	}

	doAddToCart()
	{
		if ( this.chosenInvData == null )
			return;

		let invsToCart	= [];

		_.forEach( 
			this.chosenInvData.mapInvs
		,	( inv, idInv ) =>
			{
				invsToCart.push( { idInv: idInv, idStore: this.chosenInvData.dmStore.idStore, nQty: inv.nBuyQty, sourceType: 0 } );
			}
		);

		this.storeSuggestItems	= null;

		blapp.models.fetchMultiple(
			[
				{
					name:		"_cart_result"
				,	controller:	"cart.BLCCart"
				,	method:		"addItemsToMyCart"
				,	params:		[ invsToCart, null, null, true, { location: blapp.srcmap.LOCATION.CATALOG_ITEM_STORE_XP } ]
				,	refresh:	true
				}
			,	{	
					name:		"_store_item_suggest"
				,	controller:	"finder.BLCRecommendationFinder"
				,	method:		"getRecommendedInvsByStores"
				,	params:		[ [ this.chosenInvData.dmStore.idStore ], _.map( invsToCart, ( inv ) => inv.idInv ), true ]
				,	refresh:	true
				}
			]
		).then(
			( data ) =>
			{
				let 	errorMsg		= "";
				let		cartError		= blapp.models.getError( "_cart_result" );
				let		suggestError	= blapp.models.getError( "_store_item_suggest" );

				if ( cartError != null )
				{
					errorMsg	+= "<br/>System Error : " + cartError;
				}
				else
				{
					let		cartData	= blapp.models.get( "_cart_result" );

					errorMsg	= blapp.cart.buildErrorMsg( cartData );
				}

				if ( errorMsg != "" )
				{
					this.triggerAlert( "Failed to add some items!" + errorMsg );
				}
				else
				{
					if ( suggestError == null )
					{
						this.storeSuggestItems 	= 	_.map(
														blapp.models.get( "_store_item_suggest" )
													,	( item ) =>
														{
															let	c	= item.dmItemColor.idColor > 0 ? blapp.color.get( item.dmItemColor.idColor ) : null;

															return	{
																		name:			( c ? c.strColorName + " " : "" ) + item.dmItemColor.dmItem.strItemName
																	,	link:			blapp.url2.getCatalogItemPageUrl( item.dmItemColor.dmItem, item.dmItemColor.idColor, item.dmStore.idStore, item.dmInv.idInv, item.dmInv.codeCondition, item.dmInv.codeComplete )
																	,	image:			blapp.url2.getInvImgUrl( item.dmInv, item.dmItemColor.dmImg, true )
																	,	itemNumber:		item.dmItemColor.dmItem.strItemNoFull
																	};
														}
													);
					}
					else
					{
						this.storeSuggestItems	= null;
					}

					this.setState( {showAddToCart: true} );
					this.refreshCart();
				}

				blapp.session.refresh( false );
				this.fetchInvResult();
			}
		).catch(
			( err ) =>
			{
				Alert( "Failed to add to cart : " + err );
			}
		);
	}

	doEasyBuy()
	{
	}
}

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<StoreListingsPage blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-store-listings-page' )
						);
		blapp.refs.register( "main", elem );
	}
);

var $T = BLComponent.createTextMap(
	{
		"BACK_TO_ITEM_DETAILS":
		{
			"en":	"Back to item details"
		,	"es":	"Volver a detalles del producto"
		}
	,	"ALL_LISTINGS":
		{
			"en":	"All listings"
		,	"es":	"Todos los productos"
		}
	,	"NEW":
		{
			"en":	"New"
		,	"es":	"Nuevo"
		}
	,	"USED":
		{
			"en":	"Used"
		,	"es":	"Usado"
		}
	,	"NEW_SEALED":
		{
			"en":	"New, sealed"
		,	"es":	"Nuevo, precintado"
		}
	,	"NEW_COMPLETE":
		{
			"en":	"New, complete"
		,	"es":	"Nuevo, completo"
		}
	,	"USED_COMPLETE":
		{
			"en":	"Used, complete"
		,	"es":	"Usado, completo"
		}
	,	"DOMESTIC":
		{
			"en":	"Domestic"
		,	"es":	"Doméstico"
		}
	,	"INTERNATIONAL":
		{
			"en":	"International"
		,	"es":	"Internacional"
		}
	,	"SORT_BY":
		{
			"en":	"Sort by:"
		,	"es":	"Ordenar por:"
		}
	,	"SORT_ITEM_PRICE":
		{
			"en":	"Item price (low to high)"
		,	"es":	"Precio (menos a más)"
		}
	,	"SORT_QUANTITY":
		{
			"en":	"Quantity (high to low)"
		,	"es":	"Cantidad (más a menos)"
		}
	,	"SORT_POS_FEEDBACK":
		{
			"en":	"Positive feedback (high to low)"
		,	"es":	"Feedback positivo (más a menos)"
		}
	,	"SORT_NEG_FEEDBACK":
		{
			"en":	"Negative feedback (low to high)"
		,	"es":	"Feedback negativo (menos a más)"
		}
	,	"LOADING":
		{
			"en":	"Loading..."
		,	"es":	"Cargando..."
		}
	,	"ERROR":
		{
			"en":	"Error..."
		,	"es":	"Error..."
		}
	,	"RESULTS_LIMITED":
		{
			"en":	"Results are limited up to {{$0}} stores."
		,	"es":	"Los resultados están limitados a {{$0}} tiendas."
		}
	,	"STORE":
		{
			"en":	"Store"
		,	"es":	"Tienda"
		}
	,	"FEEDBACK":
		{
			"en":	"Feedback"
		,	"es":	"Feedback"
		}
	,	"QTY":
		{
			"en":	"Qty"
		,	"es":	"Cantidad"
		}
	,	"ITEM_PRICE":
		{
			"en":	"Item price"
		,	"es":	"Precio"
		}
	,	"N_LOTS_IN_CARTS":
		{
			"en":	"{{$0?s=( lot):( lots)}} in cart"
		,	"es":	"{{$0?s=( lote):( lotse)}} en la cesta"
		}
	,	"N_COUPONS_AVAILABLE":
		{
			"en":	"{{$0?s=( coupon):( coupons)}} available"
		,	"es":	"{{$0?s=( cupón disponible):( cupones disponibles)}}"
		}
	,	"QUANTITY":
		{
			"en":	"Quantity"
		,	"es":	"Cantidad"
		}
	,	"WANTED_QTY":
		{
			"en":	"Wanted qty:"
		,	"es":	"Cantidad deseada:"
		}
	,	"CONDITION":
		{
			"en":	"Condition"
		,	"es":	"Condición"
		}
	,	"STORE_TERMS":
		{
			"en":	"Store terms and policies"
		,	"kr":	""
		,	"es":	""
		}
	}
);